export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}evaluation/evaluation-group/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        notify: {
            method: 'POST',
            url: `${url}/notify`
        },
        reportNotify: {
            method: 'POST',
            url: `${url}/report-notify`
        },
        addParticipants: {
            method: 'POST',
            url: `${url}/add-participants`,
            isArray: true
        },
        removeParticipants: {
            method: 'POST',
            url: `${url}/remove-participants`,
            isArray: true
        },
        reminderNotify: {
            method: 'POST',
            url: `${url}/reminder-notify`,
            isArray: true
        },
        notificationNotify: {
            method: 'POST',
            url: `${url}/notification-notify`,
            isArray: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/EvaluationGroup/index.js